import {Component, Injectable, Input, OnInit} from "@angular/core";
import {BaseComponent} from "../base.component";
import {Positions} from "../../model/positions.model";

@Component({
  selector: 'rebar-specification-table',
  template: `
    <div *ngIf="!loading" class="output-table">
      <h4>Rebar specification</h4>
      <table>
        <thead>
        <th>Span</th>
        <th>Left support</th>
        <th>Mid span</th>
        <th>Right support</th>
        </thead>
        <ng-container *ngFor="let span of ips.numspans.valueAsNumber | enumerate">
          <tr>
            <td class="col1">{{ rows[span][0] }}</td>
            <td class="col2">{{ rows[span][1] }}</td>
            <td class="col3">{{ rows[span][2] }}</td>
            <td class="col4">{{ rows[span][3] }}</td>
          </tr>
        </ng-container>
      </table>
    </div>
  `
})

@Injectable()
export class RebarSpecificationTableComponent extends BaseComponent implements OnInit {

  rebars: any;
  rows: string[][] = [];

  setData() {
    this.loading = true;
    this.rows = [];
    this.rebars = this.ips.output.rebarSpec;
    let spanCount = this.ips.numspans.valueAsNumber;
    let n = 0;
    for (let i = 0; i < spanCount; i++) {
      this.rows[i] = [];
      if (i < 3) {
        this.rows[i][0] = (i + 1).toString();
      } else {
        this.rows[i][0] = '4 or more';
      }
      this.rows[i][1] = this.rebars[n++];
      this.rows[i][2] = this.rebars[n++];
      this.rows[i][3] = this.rebars[n++];
    }
    console.log(" this.rows", this.rows);
    this.loading = false;
  }

  ngOnInit(): void {
    this.ips.onInputChanged.subscribe((model) => {
      this.setData();
    });
  }

}
